export default {
  overview: {
    title: "Employee-position Overview",
    archive_title: "Archived employee positions",
    subtitle: "List of all employee-positions.",
    actions: {
      create_new: "Create new employee-position",
    },
    search: {
      placeholder: "eg. Name",
    },
    table: {
      headers: {
        name: "Position",
        hourlyRate: "Hourly Rate",
        employees: "Employees",
        createdAt: "Created at",
      },
      employees: "{n} employee | {n} employees",
      empty: {
        hourlyRate: "Not set",
        employees: "Nobody",
      },
    },
  },
  detail: {
    title: "Employee-position Details",
    tabs: {
      general: "General",
      activity: "Activity",
    },
    actions: {
      update: "Save",
    },
    form: {
      name: "Name",
      hourlyRate: "Hourly Rate",
    },
  },
  create: {
    title: "Create Employee-position",
    subtitle: "Create a new Employee-position.",
  },
}
